import { render, staticRenderFns } from "./IconUpArrowFilled.vue?vue&type=template&id=11fdb769&scoped=true"
import script from "./IconUpArrowFilled.vue?vue&type=script&lang=js"
export * from "./IconUpArrowFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fdb769",
  null
  
)

export default component.exports